<template>
	<div class="flex justify-between items-center" style="height: 100%">
		<div v-for="code in codes" :key="code">
			<div v-if="services[code]">
				<!-- <vx-tooltip :text="services[code].name" placement="top"> -->
				<img
					:src="getImagePath(code.toLowerCase())"
					alt="graphic-404"
					style="width: 100%; height: 25px"
				/>
				<!-- </vx-tooltip> -->
			</div>
			<div v-else>
				-
				<!-- <vx-tooltip :text="code">- </vx-tooltip> -->
			</div>
		</div>
	</div>
</template>
  
  <script>
import fileFinderMixin from "../../../../../mixins/fileFinderMixin";
// import PropsectTechnologyPopup from "../ProspectTechnologyPopup.vue";
export default {
	// props: {
	// 	onePs: Object, // Pass the data object that contains the `id` and `url`
	// },
	name: "CmsRenderer",
	data() {
		return {
			onePs: {},
			services: {},
			codes: ["gtm", "google_analytics", "google_ads"],
		};
	},
	mixins: [fileFinderMixin],
	created() {
		this.onePs = this.params.data;
		let unformattedServices = JSON.parse(this.onePs.technologies[0].services);
		this.arrangeGoogleServices(unformattedServices);
	},
	components: {},
	methods: {
		arrangeGoogleServices(technologies) {
			let google_services = {};
			this.codes.forEach((code) => {
				let service = technologies.google_services.find(
					(tech) => tech.code === code
				);
				if (service) {
					google_services[code] = service;
				} else {
					google_services[code] = null;
				}
			});
			this.services = google_services;
		},
		// handleClick() {
		// 	this.displayTechnologies(this.onePs.id, this.onePs.url);
		// },
		// /**
		//  * Popup Issues Details
		//  * @param {Number} pid - prospect Id
		//  * @param {String} url - prospect url
		//  */
		// displayTechnologies(pid, url) {
		// 	let ComponentClass = Vue.extend(PropsectTechnologyPopup);
		// 	let technologiesPopup = new ComponentClass({
		// 		propsData: {
		// 			popupActive: true,
		// 			prsopect_id: pid,
		// 			prospect_url: url,
		// 		},
		// 	});
		// 	technologiesPopup.$mount();
		// 	this.$refs.popupContainer.appendChild(technologiesPopup.$el);
		// },
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>